module.exports = __webpack_public_path__ + "static/media/89.d33e814e.png";